import type { SelectOption } from "../../ui/select/select.tsx";

export const TAB_ASSIGN_MANAGER = "assign-manager";
export const TAB_PROMOTION_MANAGEMENT = "promotion-management";
export const TAB_DOCUMENT_APPROVAL = "document-approval";

export const EMPLOYEE_PROGRESSION_TABS = [
  { id: TAB_ASSIGN_MANAGER, label: "Assign Manager" },
  { id: TAB_PROMOTION_MANAGEMENT, label: "Promotion Management" },
  { id: TAB_DOCUMENT_APPROVAL, label: "Approve Document" },
] as const;

export type EmployeeProgressionTabId =
  (typeof EMPLOYEE_PROGRESSION_TABS)[number]["id"];

export const MANAGER_ASSIGNMENT_OPTIONS: SelectOption[] = [
  { value: "manager", label: "Manager" },
  { value: "leave-manager", label: "Leave Manager" },
];

export type ManagerAssignmentType =
  (typeof MANAGER_ASSIGNMENT_OPTIONS)[number]["value"];

